import { render } from "./dashboard-deactivations.vue?vue&type=template&id=c30b7d9e"
import script from "./dashboard-deactivations.vue?vue&type=script&lang=js"
export * from "./dashboard-deactivations.vue?vue&type=script&lang=js"
script.render = render

export default script